// frontend/src/utils/maintenance.ts
/**
 * Single source of truth for maintenance mode.
 * - MAINTENANCE_LOCK is driven by VITE_LOGIN_MAINTENANCE_LOCK
 * - Allowed emails are listed here (lowercased compare)
 * - Text message used by Login (toast) or elsewhere
 */

export const MAINTENANCE_LOCK =
  (import.meta.env.VITE_LOGIN_MAINTENANCE_LOCK ?? "").toLowerCase() === "true";

export const MAINTENANCE_ALLOWED_EMAILS = [
  "admin@elani.energy",
  "demo@elani.energy",
  // "tobias-hartmann@gmx.de",
];

export const MAINTENANCE_ALLOWED_EMAILS_LOWER = MAINTENANCE_ALLOWED_EMAILS.map((s) =>
  s.trim().toLowerCase()
);

export function isEmailAllowed(email?: string | null): boolean {
  if (!email) return false;
  const e = String(email).trim().toLowerCase();
  return MAINTENANCE_ALLOWED_EMAILS_LOWER.includes(e);
}